import { RouteType } from "types/RouteType";
import yardDashboardRoute from "./YardDashboard/YardDashboard.Route";
import yardMapRoute from "./YardMap/YardMap.Route";
import yardInventoryRoute from "./YardInventory/YardInventory.Route";
import yardTrailersRoute from "./YardTrailers/YardTrailers.Route";

const yardRoutesList: RouteType[] = [
    yardDashboardRoute,
    yardMapRoute,
    yardInventoryRoute,
    yardTrailersRoute,
];

export default yardRoutesList;
